
//import {db, functions} from "@/scripts/firebase"
//import {updateProfile} from "firebase/auth"
import {getDocs} from "firebase/firestore"
//import { GroupData } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
//import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import { GroupData } from "@/common-datatypes";
//import { User } from 'firebase';

@Component

export default class Group extends Mixins(Common) {
  groups: GroupData[] = []
  isLoading = false
  orderBy: keyof GroupData = 'creationTime'

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const theUserGroups = await getDocs(this.$getUserGroupsQuery())
      this.groups = theUserGroups.docs.map( (doc) => {
        const row = doc.data() as GroupData
        return {groupId: doc.id,...row}
      });
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  get children(): string[]{
    return this.$store.getters.myChildren || []
  }
 
 
  destroyed() {
    console.trace('destroyed');
  }

}
